import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFarm } from "services";

import { ADD_FARM, GET_FARMS } from "consts";

export const useAddFarm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FARM],
    mutationFn: addFarm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
    },
  });
};
